import { FC } from 'react';

import { purpurBreakpointLg, purpurBreakpointMd, purpurBreakpointSm } from '@purpur/library/tokens';

import { buildContentfulImageSrcSet } from '@telialt/utils/src/Contentful/contentfulImageResponsiveUrl/buildContentfulImageSrcSet';
import { contentfulImageUrl } from '@telialt/utils/src/Contentful/contentfulImageUrl';

import { ResponsiveImageGroup } from './model';

type Props = {
    images: ResponsiveImageGroup;
    className?: string;
    fetchPriority?: 'high' | 'low' | 'auto';
};

export const ResponsiveImage: FC<Props> = ({ images, className, fetchPriority }) => {
    const altText = images.altText || images.imageSm.alt || images.imageMd.alt || images.imageLg.alt || '';

    const smImage = images.imageSm;
    const mdImage = images.imageMd;
    const lgImage = images.imageLg;

    return (
        <picture className={className} data-element="Banner" data-element-name={altText}>
            <source
                srcSet={buildContentfulImageSrcSet(lgImage.src, [1200, 1920, 2048, 3840])}
                media={`(min-width: ${purpurBreakpointLg})`}
            />
            <source
                srcSet={buildContentfulImageSrcSet(mdImage.src, [828, 1080, 1200])}
                media={`(min-width: ${purpurBreakpointMd})`}
            />
            <source
                srcSet={buildContentfulImageSrcSet(smImage.src, [640, 750, 828])}
                media={`(min-width: ${purpurBreakpointSm})`}
            />
            <img
                src={contentfulImageUrl(smImage.src, smImage.width)}
                alt={altText || ''}
                width={smImage.width}
                height={smImage.height}
                fetchPriority={fetchPriority}
            />
        </picture>
    );
};
